export const Header = () => {
  return <header className="sticky mr-6 flex flex-row justify-between"></header>;
};
